<template>
  <div id="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
    </div>
    <!-- Logo -->
    <div class="logo">
      <img class="logo-img" :src="logoImg" alt="" />
    </div>
    <div class="logo-title">玄机AI业务拓展系统</div>
    <div class="phone-item">
      <img class="phone-img" :src="phoneImage" v-if="isPhone" alt="" />
      <el-input
        class="phone-input"
        placeholder="请输入手机号"
        v-model="loginForm.phone"
        @focus="focusPhone"
        clearable
      >
      </el-input>
    </div>
    <div class="phone-item">
      <img class="phone-img" :src="codeImage" alt="" />
      <el-input
        class="phone-input"
        placeholder="验证码"
        v-model="loginForm.code"
        @focus="focusCode"
      >
      </el-input>
      <div v-if="showCode">
        <span class="code-text" v-if="!isCode"> 发送验证码 </span>
        <span class="code-text2" v-else @click="handleCode"> 发送验证码 </span>
      </div>
      <div v-else>
        <span class="code-text2"> {{ time }}S </span>
      </div>
    </div>
    <!-- 自动登录 -->
    <div class="auto-login">
      <el-checkbox v-model="autoChecked" @change="handleAutoChecked"
        >自动登录</el-checkbox
      >
    </div>
    <div class="login">
      <el-button @click="handleLogin">登录</el-button>
    </div>
    <!-- footer -->
    <div class="footer">
      Copyright@ {{ currentYear }} 深圳市玄机人工智能科技有限公司
    </div>

    <div class="message" v-if="show">
      <div class="tip">{{ message }}</div>
    </div>
  </div>
</template>
  
  <script>
// import { getToken } from '@/utils/auth'
import { verificationCodes } from "@/api/home";
export default {
  name: "LoginPage",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      currentYear: "",
      autoChecked: false,
      loginForm: {
        phone: "",
        code: "",
      },
      message: "手机号错误",
      showCode: true,
      time: 60,
      show: false,
      isCode: false,
      phone: "",
      code: "",
      drawer: false,
      direction: "btt",
      isPhone: true,
      env: process.env.VUE_APP_BASE_API,
      logoImg: require("@/assets/logo.png"),
      closeImage: require("@/assets/close.png"),
      phoneImage: require("@/assets/phone.png"),
      codeImage: require("@/assets/code.png"),
      emailImage: require("@/assets/email.png"),
    };
  },
  watch: {

  },
  async mounted () {
    this.autoChecked = localStorage.getItem("autoChecked") === 'true' ? true : false
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
  },
  methods: {
    handleAutoChecked () {
      localStorage.setItem("autoChecked", this.autoChecked)
    },
    validateInternational (number) {
      const regex = /^\+?[0-9]{1,4}\s?\d{7,14}$/; // +CCC格式或本地号码
      return regex.test(number);
    },
    handleLogin () {
      if (!this.loginForm.phone) {
        this.show = true
        this.message = "手机号错误"
        setTimeout(() => {
          this.show = false
        }, 3000)
        return;
      }
      const pass = this.validateInternational(this.loginForm.phone)
      if (!pass) {
        this.show = true
        this.message = "手机号错误"
        setTimeout(() => {
          this.show = false
        }, 3000)
        return
      }
      if (!this.loginForm.code) {
        // 请输入验证码
        this.show = true
        this.message = "验证码错误"
        setTimeout(() => {
          this.show = false
        }, 3000)
        return;
      }
      this.$store
        .dispatch("user/login", this.loginForm)
        .then(() => {
          this.$toast('登录成功');
          this.$router.push({
            path: "/home",
          });
        })
        .catch(() => {
          console.log("login-error");
        });
    },
    focusCode () {
      this.isCode = true;
    },
    focusPhone () {
      this.isCode = false;
    },
    goBack () {
      this.$router.push({
        path: "/home",
      });
    },
    delay (ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    },
    async startCountdown (seconds) {
      for (let i = seconds; i > 0; i--) {
        this.time = i;
        await this.delay(1000);
      }
      this.showCode = true;
    },
    handleCode () {
      if (!this.loginForm.phone) {
        this.message = "请先输入手机号";
        this.show = true;

        setTimeout(() => {
          this.show = false;
        }, 1500);
        return;
      }

      const data = {
        type: "sms",
        phoneNumber: this.loginForm.phone,
      };

      const pass = this.validateInternational(this.loginForm.phone)
      if (!pass) {
        this.show = true
        this.message = "手机号错误"
        setTimeout(() => {
          this.show = false
        }, 3000)
        return
      }
      verificationCodes(data).then((res) => {
        if (res?.data?.status) {
          this.showCode = false;
          this.startCountdown(60);
        }
      });
    },
  },
};
</script>
  
  <style scoped>
#app {
  height: 100vh;
  text-align: left;
  padding: 0px 16px;
  background: linear-gradient(180deg, #f9eae7 17%, #fcf9f7 70%, #f5f5f5 100%);
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.fanyi-img {
  width: 18px;
  height: 18px;
  line-height: 16px;
  float: right;
  /* padding-top: 10px; */
  margin: 10px 16px 0px 0px;
  cursor: pointer;
  border: 2px solid #201f34;
  font-size: 12px;
}
.share-img {
  width: 24px;
  height: 24px;
  float: right;
  padding-top: 10px;
  cursor: pointer;
}
.title {
  font-family: PingFang SC;
  font-size: 36px;
  font-weight: 600;
  line-height: 54px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin: 26px 26px 26px 10px;
}

.phone {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  color: #3d3d3d;
  padding: 0px 24px 0px 8px;
}
.email {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.line {
  width: 57px;
  height: 2px;
  /* 2-辅色 */
  background: #201f34;
  margin: 8px auto;
}
.phone-item {
  position: relative;
  margin: 33px 8px 24px 8px;
}
.phone-img {
  position: absolute;
  top: 14px;
  left: 16px;
  z-index: 999;
  width: 24px;
  height: 24px;
}
.phone-input >>> .el-input__inner {
  border-radius: 8px;
  background: #ffffff;
  height: 54px;
  padding-left: 50px;
  font-size: 16px;
}
.code-text {
  position: absolute;
  right: 16px;
  top: 16px;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 沉底色 */
  color: #bfbfc1;
}
.code-text2 {
  position: absolute;
  right: 16px;
  top: 16px;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: right;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #f65e3d;
}
.agreement {
  display: flex;
  margin-bottom: 33px;
}
.agreement-text {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  font-variation-settings: "opsz" auto;
  color: #8d8d8d;
}
.agreement-item {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-variation-settings: "opsz" auto;
  font-family: PingFang SC;
  color: #201f34;
  cursor: pointer;
}

.login {
  width: 100%;
}
::v-deep .el-button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
}

.pop {
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 99999;
}
.tip1 {
  /* 自动布局子元素 */
  width: calc(100% - 64px);
  /* height: 96px; */
  /* 自动布局 */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 999;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
  /* margin: 0 auto; */

  font-family: AlibabaPuHuiTi;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;

  font-feature-settings: "kern" on;
  /* 文本色 */
  color: #0e273b;
}
.tip_button {
  display: flex;
  width: 100%;
  text-align: center;
}
.tip_left {
  flex: 1;
  border-radius: 0px 0px 0px 16px;
  /* 卡片色 */
  background: #ffffff;
  box-sizing: border-box;
  /* 背景色 */
  border-width: 1px 1px 0px 0px;
  border-style: solid;
  border-color: #f5f5f5;
  padding: 12px 0px;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  /* 文本色 */
  color: #0e273b;
}
.tip_right {
  flex: 1;
  border-radius: 0px 0px 16px 0px;
  /* 卡片色 */
  background: #ffffff;
  box-sizing: border-box;
  /* 背景色 */
  border-width: 1px 0px 0px 0px;
  border-style: solid;
  border-color: #f5f5f5;
  padding: 12px 0px;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  /* 品牌色 */
  color: #f65e3d;
}
.mask {
  position: fixed;
  left: 0px;
  top: 0px;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.2) !important;
  z-index: 9999;
}
.pop-title {
  padding: 24px 24px 0px 24px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  color: #201f34;
}
.pop-content {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  color: #8e8e8e;
  padding: 0px 24px 24px 24px;
}
.color1 {
  color: #201f34;
  cursor: pointer;
}

.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  line-height: 60px;
}
.tip {
  width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 0px 20px;
}

.drawer >>> .el-drawer.btt {
  border-radius: 16px 16px 0px 0px;
  background: #f6f8fa;
}
.drawer >>> .el-drawer__header {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.drawer-item {
  padding: 0px 16px;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
}
.drawer-content {
  display: flex;
  height: 20px;
  line-height: 20px;
  padding: 14px 16px;
}
.checked-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.item-left {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #201f34;
  padding: 0px 5px;
}
.item-right {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #8e8e8e;
}
.drawer >>> .el-drawer__body {
  padding: 0px 16px;
  margin-top: -10px;
}

.logo {
  width: 85px;
  margin: 24px auto;
}
.logo-img {
  width: 85px;
  height: 85px;
}
.logo-title {
  text-align: center;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #0e273b;
}

.login >>> .el-button {
  width: 100%;
  height: 44px;
  background-color: #f65e3d;
  color: #ffffff;
  border-radius: 22px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  margin-top: 30px;
}
.auto-login {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #0e273b;
  text-align: center;
}

::v-deep .el-checkbox__inner {
  border: 1px solid #bfbfc1;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #f65e3d;
  border: 1px solid #ffffff;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0e273b;
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 37px;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #8d8d8d;
  text-align: center;
  margin: 0 auto;
}
</style>
  